<template>
  <modal :show="visible" @close="visible = false" :gradient="'info'">
    <div slot="header">
      Cập Người Phụ Trách
    </div>
    <template>
      <block transparent="true" :nobody="true" ref="bmdal">
        <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
          <form role="form" @submit.prevent="handleSubmit">
            <b-row>
              <b-col cols="12">
                <div class="text-light mb-4" v-if="user.userManage">
                  Người hiện tại : <strong>{{ user.userManage.name }}</strong>
                </div>
              </b-col>
              <b-col cols="12" class="mb-4">
                <label class="form-control-label text-light">
                  Chọn người phụ trách
                </label>
                <ValidationProvider name="mật khẩu" rules="required">
                  <!-- :options="roles" -->
                  <base-select
                    label="Người phụ trách"
                    v-model="userManage"
                    :ajaxData="getUser"
                  >
                    <template v-slot:selected="{ item }">
                      <div>
                        {{ item.name }}
                      </div>
                    </template>
                    <template v-slot:body="{ item }">
                      <div class="d-flex">
                        <span class="avatar avatar-sm rounded-circle mr-2">
                          <img
                            v-holder="{
                              img: '40x40',
                              text: item.name
                            }"
                            @error="$imgHolder"
                            :alt="item.name"
                            :src="$mediaURI + item.avatar"
                          />
                        </span>
                        <div>
                          <strong>{{ item.name }}</strong>
                          <br />
                          <span>{{ item.phone }}</span>
                        </div>
                      </div>
                    </template>
                  </base-select>
                </ValidationProvider>
              </b-col>
            </b-row>
          </form>
          <b-row>
            <b-col sm="6" xs="12" md="6">
              <b-button
                class="mb-2"
                type="submit"
                block
                variant="dark"
                @click="doSave(0)"
              >
                Lưu đóng (F4)
              </b-button>
            </b-col>
            <b-col sm="12" md="6">
              <b-button
                class="mb-2"
                block
                variant="secondary"
                @click="handleClose"
              >
                Đóng (Esc)
              </b-button>
            </b-col>
          </b-row>
        </ValidationObserver>
      </block>
    </template>
  </modal>
</template>
<script>
import { userService, customerService } from "@/_services";
import { mapState } from "vuex";
export default {
  name: "add-button",
  props: {},
  data() {
    return {
      visible: false,
      userManage: 0,
      user: {},
      ownInfo: {}
    };
  },
  computed: {
    ...mapState("user", ["info"])
  },
  methods: {
    setData(user) {
      this.ownInfo = user;
      this.user = Object.assign({}, user);
      if (user.userManage) this.userManage = user.userManage;
      else this.userManage = "";
    },
    doSave(type) {
      var self = this;
      if (!this.visible) return;
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        this.$refs.bmdal.block();
        customerService
          .updateUserManage(self.user.id, self.userManage)
          .then(res => {
            self.ownInfo.userManage = res.data.userManage;
            if (type == 0) {
              self.visible = false;
            }
            this.$alertify.success(res.message, {
              duration: 4000
            });
          })
          .catch(err => {
            if (err.data) {
              err.data.forEach(element => {
                let errObj = {};
                errObj[element.context.key] = [element.message];
                self.$refs.csInfo.setErrors(errObj);
              });
            }
          })
          .finally(() => {
            this.$refs.bmdal.unBlock();
          });
      });
    },
    handleClose() {
      this.visible = false;
    },
    getUser(keyword, cb) {
      userService.adminGetAllUser({ search: keyword }).then(res => {
        let data = res.data.data;
        data.push(this.info);
        data.push({
          id: -1,
          name: "Tất cả nhân viên"
        });
        cb(data);
      });
    }
  }
};
</script>
